export default {
  emissionCheck_unit: "Unit",
  emissionCheck_edit: "Edit",
  emissionCheck_scan: "Scan",
  emissionCheck_delete: "Delete",
  emissionCheck_vehicle: "Vehicle",
  emissionCheck_vin: 'VIN',
  emissionCheck_status: 'Status',
  emissionCheck_lastScanDate: 'Last Scan Date',
  emissionCheck_lastScanStatus: 'Last Scan Status',
  emissionCheck_nextDeadline: 'Next Deadline',
  emissionCheck_viewEvents: 'View events',
  emissionCheck_import: 'Import',
  emissionCheck_export: 'Export',
  emissionCheck_advancedFilters: "Advanced Filters",
  emissionCheck_clearFilters: "Clear filters",
  emissionCheck_all: "All",
  emissionCheck_notRegistered: "Not Registered",
  emissionCheck_waiting: "Waiting",
  emissionCheck_compliant: "Compliant",
  emissionCheck_notCompliant: "Not compliant",
  emissionCheck_requested: "Requested",
  emissionCheck_complete: "Complete",
  emissionCheck_submitted: "Submitted",
  emissionCheck_pass: "Pass",
  emissionCheck_fail: "Fail",
  emissionCheck_error: "Error",
  emissionCheck_scanDate: "Scan Date",
  emissionCheck_registerDate: "Register Date",
  emissionCheck_tags: "Tags",
  emissionCheck_viewError: "View Error",
  emissionCheck_hideError: "Hide Error",
  emissionCheck_deleteTitle: "Unsubscribe Emission check",
  emissionCheck_deleteConfirm: "Are you sure you want to unsubscribe the vehicle(s)?",
  emissionCheck_editVehicle: "Edit Vehicle",
  emissionCheck_registerVehicle: "Register Vehicle",
  emissionCheck_addedSuccessfully: 'Emission check was created successfully',
  emissionCheck_updatedSuccessfully: 'Emission check was updated successfully',
  emissionCheck_deleteSuccessfully: 'Emission check was deleted successfully',
  emissionCheck_scanEventsSuccessfully: 'Events loaded successfully. Click on this message to view events loaded',
  emissionCheck_scanEventsError: 'There are no new events available, please try again later',
  emissionCheck_download_file: 'Download attached file',
  emissionCheck_eventsResume: 'Events loaded resume',
  emissionCheck_search: "Search by Vehicle or VIN",
  emissionCheck_template: "Download template",
  emissionCheck_template_file: "Download current asset list",
  emissionCheck_descriptonImport: "Import CSV File",
  emissionCheck_semicolon: 'Semicolon',
  emissionCheck_comma: 'Comma',
  emissionCheck_error_required: "Required File CSV",
  emissionCheck_file: "File",
  emissionCheck_upload: "Upload",
  emissionCheck_aceept_file: "Only accept csv files",
  emissionCheck_delimiter: "Delimiter",
  emissionCheck_regState: "Registration State",
  emissionCheck_regCountry: "Registration Country",
  emissionCheck_regExpDate: "Registration Expiration Date",
  emissionCheck_enrolled: "Enrolled",
  emissionCheck_error: 'Error',
  emissionCheck_error_delimiter: "Error in file, please review the delimiter",
  emissionCheck_error_data_required: "All fields are required",
  emissionCheck_error_data_repeat_file: "VIN is repeated",
  emissionCheck_error_regState_long: "Registration State are 2 characters",
  emissionCheck_error_regCountry_long: "Registration Country State are 3 characters",
  emissionCheck_error_vin_chars: 'VIN are 17 characters',
  emissionCheck_error_fix: "Please fix errors before continuing",
  emissionCheck_error_started: "The import has been started, you will be notified when completed",
  emissionCheck_error_enrolled: "Enrolled has to be TRUE or FALSE",
  emissionCheck_error_RegExpDate: "Registration Expiration Date is not valid",
  emissionCheck_error_import: "There was an unknow error in the importation",
  emissionCheck_result_import: "Importation result",
  emissionCheck_result_import_fail: "The import was not successful, check all the data because if any of them has error it will not import correctly",
  emissionCheck_result: "Result",
  emissionCheck_field: "FIELD",
  emissionCheck_requirements: "REQUIREMENTS",
  emissionCheck_text_import_head: "To get started, download our helpful template below.",
  emissionCheck_vin_requirements: 'Fixed length: 17 characters',
  emissionCheck_regState_requirements: "2-character state abbreviation example: 'CA' for California",
  emissionCheck_regCountry_requirements: "3-character iso3 country format example: 'USA'",
  emissionCheck_regExpDate_requirements: "ISO date format yyyy-mm-dd example: '2024-10-31'",
  emissionCheck_enrolled_requirements: "Set to 'FALSE' to un-enroll the vehicle",
  emissionCheck_text_import_foot: "Spreadsheet applications like Google Sheets or Microsoft Excel may display dates in a different format, such as mm/dd/yyyy. Refer to your application's help or documentation to learn how to change date formats."
}